import { endpoints } from "config/endpoints.config"
import { IGenericModel, generic } from "models/generic"
import { IWorkspace } from "./workspaces"

export interface IPartnerWorkspace extends IWorkspace {}

export const partnerWorkspaces: IGenericModel<IPartnerWorkspace> = {
    ...generic(endpoints.PARTNER_WORKSPACES),
}
